export const REDIRECT_URL = process.env.REACT_APP_ICS2_FRONTEND_URL || 'http://localhost:82/';
export const ICS2_CLIENTID = process.env.REACT_APP_ICS2_CLIENTID || 'daf8febb-65fa-419a-9d72-90a3779dc3f6';
export const EORICUSTOMTECH_DOMAIN = process.env.REACT_APP_EORICUSTOMTECH_DOMAIN || 'Eoricustomtech';
export const EORICUSTOMTECH_TENANTID =
  process.env.REACT_APP_EORICUSTOMTECH_TENANTID || 'e43f36b5-975f-4983-8447-eec73ed210ed';
export const LANDINGPAGE_URL = process.env.REACT_APP_SSO_FRONTEND_URL || 'http://localhost:3000/';

const trimmedRedirectUrl = REDIRECT_URL.endsWith('/') ? REDIRECT_URL.slice(0, -1) : REDIRECT_URL;
export const blankRedirectUrl = trimmedRedirectUrl + '/blank.html';

export const msalConfig = {
  auth: {
    clientId: ICS2_CLIENTID,
    authority: `https://${EORICUSTOMTECH_DOMAIN}.ciamlogin.com/${EORICUSTOMTECH_TENANTID}/v2.0/`,
    knownAuthorities: [`${EORICUSTOMTECH_DOMAIN}.ciamlogin.com`],
    redirectUri: REDIRECT_URL,
    postLogoutRedirectUri: LANDINGPAGE_URL,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};
